import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { MenuService } from './app.menu.service';
import { DataService } from './services/data.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    constructor(
        public appMain: AppMainComponent,
        private menuService: MenuService,
        private dataService: DataService,
    ) { }

    async ngOnInit() {
        this.model = await this.menuService.getTareasData();
    }
}
